module.exports = __webpack_public_path__ + "static/media/cloudvps2.1bd38db4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flat/cloudvps2.svg
// module id = 274
// module chunks = 0